import React from "react";
import {
  QRCODE_ACTIVE_STATUS,
  QRCODE_CANCELLED_STATUS,
  QRCODE_CHECKEDIN_STATUS,
  QRCODE_CHECKEDOUT_STATUS,
  QRCODE_EXPIRED_STATUS,
} from "../../../constants";
import {getCustomerSlotDetails} from "../../../services/SessionStorage";
import {useTranslation} from "react-i18next";
import BookingDetailList from "../../../components/BookingDetailList";
import QRCode from "qrcode.react";

const ConfirmedBookingOffice = ({data}) => {
  const {t} = useTranslation();
  const qrMessageMapping = {
    [QRCODE_ACTIVE_STATUS]: t("congratulations.label"),
    [QRCODE_EXPIRED_STATUS]: t("qrexpired.error"),
    [QRCODE_CANCELLED_STATUS]: t("qrcancelled.error"),
    [QRCODE_CHECKEDIN_STATUS]: t("checkedin.label"),
    [QRCODE_CHECKEDOUT_STATUS]: t("checkedout.label"),
  };
  const info = getCustomerSlotDetails();
  const {
    location,
    storeName,
    serviceType,
    startTime,
    timeZone,
    endTime,
    businessUnit,
  } = info.fetchOnlyQR[0];
  return (
    <main className="officequestions">
      <div className="officequestions-container">
        <BookingDetailList
          endTime={endTime}
          isOffice={info.isOffice}
          region={location}
          serviceType={serviceType}
          startTime={startTime}
          storeName={storeName}
          timeZone={timeZone}
          country={info.country}
          bu={businessUnit}
        />
        <div className="flex">
          <QRCode
            id="slotbook-qrcode"
            value={data.apiResponse}
            renderAs={"png"}
            className="qr-code"
            size={256}
          />
        </div>
      </div>
    </main>
  );
};

export default ConfirmedBookingOffice;
